import './config/polyfills';
import * as React from 'react';
import ReactDOM from 'react-dom';
import 'rxjs';
import { Provider } from 'react-redux';
import App from './App';
import history from './history';
import buildStore from './store';
import { AppContainer } from 'react-hot-loader';
import remoteLogErrorHandler from './config/remote-log-error-handler';
import 'gjensidige-fonts/fonts.css';
import requestInterceptor from './services/request-interceptor/request-interceptor-service';
import clientIdentification from 'gje-client-identification';

window.onerror = remoteLogErrorHandler;

requestInterceptor.configure();

declare const __REVISION__: string;

clientIdentification.configure({
    applicationId: 'INTERNETT',
    clientName: 'webshop-sweden',
    clientVersion: __REVISION__
});

const store = buildStore(history);

function renderRoot(Component) {
    const root = document.getElementById('app');

    if (root) {
        ReactDOM.render(
            <AppContainer>
                <Provider store={store}>
                    <Component />
                </Provider>
            </AppContainer>,
            root
        );
    }
}

renderRoot(App);

if (module.hot) {
    module.hot.accept('./App', () => renderRoot(App));
}
